import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
// services
import { CmxAuthProfile, SessionService } from '@cemex-core/angular-services-v8';

// interfaces
import { ILegalEntity } from '@cemex-core/types-v2';
import { Application } from './../../cemexcomponents/types/v2/';
import { UserInfo, Customer, Company, FinancialDocument, LienReleaseRequest,
        Dispute, JsonObj, DocumentReference } from './../../cemexcomponents/types/v2/';
import { Router } from '@angular/router';
import { ListnavItem } from './../components/listnav/';
import { ILanguage } from '@cemex-core/angular-localization-v7';
import { StorageManagerService } from '@app/core/services/storage-manager.service';


interface Data {
    company?: Company;
    status?: string;
    checkedDocuments?: Array<FinancialDocument>;
    document?: FinancialDocument;
    returnFinancialDoc?: number;
    customer?: Customer;
    dateRange?: any;
    checkedDocumentsReferences?: Array<DocumentReference>;
    dataRefPay?: any;
    jsonObjData?: JsonObj; // json data decoded to send/recieve between products
    payParams?: {
        flagCLRINV?: boolean;
        flagMULTPAY?: boolean;
        flagMULTCLRENT?: boolean;
        flagREASONCODE?: boolean;
        flagDUEDOCS?: boolean;
        flagPRTPAY?: boolean;
        flagCUSTPRTPAY?: boolean;
    };
    docsFromXLSFile?: Array<FinancialDocument>;
    countryCode?: string;
    listNavItem?: ListnavItem;
    defaultCompany?: any;
    defaultCustomer?: any;
    parametersCountry?: any;
    parametersCustomer?: any;
    currencySymbol?: string;
    decimalNumbers?: number;
    decimalNumbersMoney?: number;
    decimalSeparator?: string;
    thousandSeparator?: string;
    jpMorganStatus?: string;
    boaStatus?: string;

}

@Injectable()
/**
 * @deprecated see /core/helpers for alternatives
 * */
export class StoredData {
    public lienreleaserequest: LienReleaseRequest;
    public allCompanies: Company = { companyCode: '0', companyDesc: 'All CEMEX subsidiaries',
        countryCode: this.getCurrentCountry(), divisionCode: 0 };
    private dispute: Dispute;
    private userInfo: UserInfo;
    private profile: CmxAuthProfile;
    private userLegalEtity: any;
    private notify = new Subject<any>();
    private data: Data = {};
    private applicationCode = 'INVOICE_PAYMENTS';
    private applications: Array<Application> = [];
    private legalEntity: ILegalEntity;
    public legalEntityListener: Observable<ILegalEntity>;
    private isMobileDevice: boolean;

    constructor(private session: SessionService, private router: Router, private storageManagerService: StorageManagerService,
    ) {
        this.initialize();
    }

    private initialize(): void {
        this.setCountry();
        this.applications = this.getUserApplications();
        this.legalEntityListener = this.session.currentLegalEntity;
        this.data.payParams = {};
        this.setCurrencyFormats();
    }

    public getCurrentCountry(): string {
        if (sessionStorage.getItem('country') !== undefined && sessionStorage.getItem('country') !== null) {
            return sessionStorage.getItem('country');
        }

        return undefined;
    }


    public getUserApplications(): Array<Application> {
        if (this.storageManagerService.user_applications !== undefined && this.storageManagerService.user_applications !== null) {
            return this.storageManagerService.user_applications;
        }

        return undefined;
    }

    // =======================================================================================================================
    // Stored Data session storage
    // =======================================================================================================================

    private recoverStoredData(): void {
        if (sessionStorage.getItem('stored_data') !== undefined && sessionStorage.getItem('stored_data') !== null) {
            this.data = JSON.parse(sessionStorage.getItem('stored_data'));
        }
    }

    private saveStoredData(): void {
        sessionStorage.setItem('stored_data', JSON.stringify(this.data));
    }

    // =======================================================================================================================
    // user profile
    // =======================================================================================================================

    public getUserInfo(): UserInfo {
        return this.userInfo;
    }

    public setUserInfo(): void {
        const auxTokenData = this.storageManagerService.token_data;
        if (auxTokenData) {
            this.userInfo = auxTokenData;
        }
        this.data.payParams = {};
    }


    /** @deprecated use core/helpers/session-storage */
    public getUserProfile(): CmxAuthProfile {
        if (this.profile === undefined) {
            this.setUserProfile();
        }

        return this.profile;
    }

    public setUserProfile(): void {
        const auxTokenData = this.storageManagerService.user_profile;
        if (auxTokenData) {
            this.profile = auxTokenData;
        }
        this.data.payParams = {};
    }

    public getUserLegalEntityRefresh(legal: any): boolean {
        let result = false;

        if (this.userLegalEtity === undefined) {
            this.setUserLegalEntity();
        }

        if (this.userLegalEtity.legalEntityTypeCode !== legal.legalEntityTypeCode) {
            this.userLegalEtity.legalEntityTypeCode = legal.legalEntityTypeCode;
            result = true;
            // this.router.navigate(["/invoices-payments/financial-documents"]);
        }
        return result;
    }

    public setUserLegalEntity(): void {
        const auxTokenData = JSON.parse(sessionStorage.getItem('user_legal_entity'));
        if (auxTokenData) {
            this.userLegalEtity = auxTokenData;
        }
        this.data.payParams = {};
    }

    // =======================================================================================================================
    // company
    // =======================================================================================================================

    public setCustomer(aux: Customer): void {
        if (aux !== undefined) {
            this.recoverStoredData();
            this.data.customer = aux;
            this.saveStoredData();
        }
    }

    public getCustomer(): Customer {
        this.recoverStoredData();
        return this.data.customer;
    }

    // =======================================================================================================================
    // date range
    // =======================================================================================================================

    public setDateRange(aux: any): void {
        this.recoverStoredData();
        this.data.dateRange = aux;
        this.saveStoredData();
    }

    public getDateRange(): any {
        this.recoverStoredData();
        return this.data.dateRange;
    }


    public setReturnFinancialDoc(aux: number): void {
        this.recoverStoredData();
        this.data.returnFinancialDoc = aux;
        this.saveStoredData();
    }

    public getReturnFinancialDoc(): number {
        this.recoverStoredData();
        return this.data.returnFinancialDoc;
    }

    public setDocument(financialDocument: FinancialDocument): void {
        this.recoverStoredData();
        this.data.document = financialDocument;
        this.saveStoredData();
    }

    public getDocument(): FinancialDocument {
        this.recoverStoredData();
        return this.data.document;
    }

    // =======================================================================================================================
    // Document center
    // =======================================================================================================================

    public setCheckedDocumentsReferences(documents: Array<DocumentReference>): void {
        this.recoverStoredData();
        this.data.checkedDocumentsReferences = documents;
        this.saveStoredData();
    }

    public getCheckedDocumentsReferences(): Array<DocumentReference> {
        this.recoverStoredData();
        return this.data.checkedDocumentsReferences;
    }

    // =======================================================================================================================
    // lien Release
    // =======================================================================================================================

    public setLienReleaseRequest(lienreleaserequest: LienReleaseRequest): void {
        this.lienreleaserequest = lienreleaserequest;
    }

    public getLienReleaseRequest(): LienReleaseRequest {
        return this.lienreleaserequest;
    }

    // =======================================================================================================================
    // disputes
    // =======================================================================================================================

    public setDisputes(dispute: Dispute): void {
        this.dispute = dispute;
    }

    public getDisputes(): any {
        return this.dispute;
    }

    // =======================================================================================================================
    // parameter settings
    // =======================================================================================================================

    // =======================================================================================================================
    // reference payment data in cancel reference payment view
    // =======================================================================================================================

    public setDataRefPay(aux: any): void {
        if (aux !== undefined) {
            this.data.dataRefPay = aux;
            this.saveStoredData();
        }
    }

    public getDataRefPay(): any {
        this.recoverStoredData();
        return this.data.dataRefPay;
    }

    // =======================================================================================================================
    // json object data decoded
    // =======================================================================================================================

    public setJsonObjData(aux: JsonObj): void {
        if (aux !== undefined) {
            this.data.jsonObjData = aux;
            this.saveStoredData();
        }
    }

    public getJsonObjData(): JsonObj {
        this.recoverStoredData();
        return this.data.jsonObjData;
    }

    //////////////////////////////////////
    // For use in reconcile.component
    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }
    ///////////////////////////////////////

    // =======================================================================================================================
    // set payment configuration parameters
    // =======================================================================================================================

    public setPayParams(aux: boolean, param: string): void {
        if (aux !== undefined) {
            switch (param) {
                case 'CLRINV':
                    this.data.payParams.flagCLRINV = aux;
                    break;
                case 'MULTPAY':
                    this.data.payParams.flagMULTPAY = aux;
                    break;
                case 'MULTCLRENT':
                    this.data.payParams.flagMULTCLRENT = aux;
                    break;
                case 'REASONCODE':
                    this.data.payParams.flagREASONCODE = aux;
                    break;
                case 'DUEDOCS':
                    this.data.payParams.flagDUEDOCS = aux;
                    break;
                case 'PRTPAY':
                    this.data.payParams.flagPRTPAY = aux;
                    break;
                case 'CUSTPRTPAY':
                    this.data.payParams.flagCUSTPRTPAY = aux;
                    break;
                default:
                    break;
            }
            this.saveStoredData();
        }
    }

    public saveCountryParameters(configuration: any): void {
        this.recoverStoredData();
        this.data.parametersCountry = configuration;
        this.saveStoredData();
    }

    public getCountryParameters(): any {
        this.recoverStoredData();
        return this.data.parametersCountry;
    }

    public saveCustomerParameters(configuration: any): void {
        this.recoverStoredData();
        this.data.parametersCustomer = configuration;
        this.saveStoredData();
    }

    public getCustomerParameters(): any {
        this.recoverStoredData();
        return this.data.parametersCustomer;
    }

    public getPayParams(): any {
        this.recoverStoredData();
        return this.data.payParams;
    }


    // =======================================================================================================================
    // HTML validations
    // =======================================================================================================================

    // =======================================================================================================================
    // imported documents from file to reconcile
    // =======================================================================================================================

    public setDocsFromXLSFile(documents: Array<FinancialDocument>): void {
        if (document !== undefined) {
            this.recoverStoredData();
            this.data.docsFromXLSFile = documents;
            this.saveStoredData();
        }
    }

    public getDocsFromXLSFile(): Array<FinancialDocument> {
        this.recoverStoredData();
        return this.data.docsFromXLSFile;
    }

    // =======================================================================================================================
    // set/get country of the logged user
    // =======================================================================================================================

    public setCountry(): void {
                this.recoverStoredData();
            this.data.countryCode = sessionStorage.getItem('country');
            this.saveStoredData();
    }

    public getDefaultCompany(): any {
        this.recoverStoredData();
        return this.data.defaultCompany;
    }

    public getCountry(): string {
        if (sessionStorage.getItem('country') !== undefined && sessionStorage.getItem('country') !== null) {
            this.recoverStoredData();
            return this.data.countryCode.trim();
        }
    }

    public initPayParams(): void {
        this.data.payParams = {};
    }

    public reInitialize(): void {
        this.setCountry();
        this.applications = this.getUserApplications();
        this.legalEntityListener = this.session.currentLegalEntity;
        this.data.payParams = {};
        this.setCurrencyFormats();
    }

    public setListNavItem(item: ListnavItem): void {
        this.recoverStoredData();
        this.data.listNavItem = item;
        this.saveStoredData();
    }

    public getListNavItem(): ListnavItem {
        this.recoverStoredData();
        return this.data.listNavItem;
    }

    public setIsMobileDevice(val: string): void {
        if (val === 'True') {
            this.isMobileDevice = true;
        }
    }

    public IsMobileDevice(): boolean {
        return this.isMobileDevice;
    }

    private _popup: any;

    public checkCanOpenPopups(): Promise<boolean> {
        const features = 'width=1, height=1, left=100000, top=100000, scrollbars, resizable';
        this._popup = window.open('', 'msg', features);
        let result: boolean;

        if (this._popup === null || typeof (this._popup) === 'undefined') {
            result = true;
        } else {
            this._popup.close();
            this._popup = window.open('', 'msg', features);
            if (this._popup === null || typeof (this._popup) === 'undefined') {
                result = true;
            } else {
                this._popup.close();
                result = false;
            }
        }

        return Promise.resolve(result);
    }

    public setCurrencyFormats(): void {
        const l = window['CMX_LANGUAGES'] as Array<any>;
        this.recoverStoredData();

        const currentCountry: string = (this.getCurrentCountry() && this.getCurrentCountry().trim()) || 'US';
        const currentLanguage: ILanguage = l.find( l => l.countryCode === currentCountry);

        this.data.currencySymbol = (currentLanguage && currentLanguage.currencySymbol) || '$';
        this.data.decimalNumbers = Number((currentLanguage && currentLanguage.decimalNumbers)) || 3;
        this.data.decimalNumbersMoney = Number(currentLanguage && currentLanguage.decimalNumbersMoney) || 2;
        this.data.decimalSeparator = (currentLanguage && currentLanguage.decimalSeparator) || '.';
        this.data.thousandSeparator = (currentLanguage && currentLanguage.thousandSeparator) || ',';

        this.saveStoredData();
    }

    public getCurrencySymbol(): string {
        this.recoverStoredData();
        return this.data.currencySymbol;
    }

    public getDecimalNumbers(): number {
        this.recoverStoredData();
        return this.data.decimalNumbers;
    }

    public getDecimalNumbersMoney(): number {
        this.recoverStoredData();
        return this.data.decimalNumbersMoney;
    }

    public getDecimalSeparator(): string {
        this.recoverStoredData();
        return this.data.decimalSeparator;
    }

    public getThousandSeparator(): string {
        this.recoverStoredData();
        return this.data.thousandSeparator;
    }

    public getRefreshToken(): string {
        return this.storageManagerService.refresh_token;
    }

    public getUserForPSETests(): boolean {
        return true;
    }

  // =======================================================================================================================
  // set/get JP Morgan
  // =======================================================================================================================

  public getJpMorganStatus(): string {
    this.recoverStoredData();
    return this.data.jpMorganStatus;
  }

  public setJpMorganStatus(status: string) {
    this.data.jpMorganStatus = status;
    this.saveStoredData();
  }

  // =======================================================================================================================
  // set/get BOA
  // =======================================================================================================================

  public getBofaStatus(): string {
    this.recoverStoredData();
    return this.data.boaStatus;
  }

  public setBofaStatus(status: string) {
    this.data.boaStatus = status;
    this.saveStoredData();
  }

}
